// import axios from "axios"
import axios from "./../common/axiosInstance";
import {QueryParamsFormat} from "./Http-utils";

const HttpActualGet = (path, parameters, azureSubscriptionKey, xProfileUid, accessToken) => {
    
    let headers = {}

    if (accessToken) {
        headers = {
            ...headers,
            Authorization: `Bearer ${accessToken}`
        };
    }
    
    if (azureSubscriptionKey) {
        headers = {
            ...headers,
            'Ocp-Apim-Subscription-Key': azureSubscriptionKey
        };
        
    }

    if (xProfileUid) {
        headers = {
            ...headers,
            "x-profile-uid": xProfileUid
        };
    }
    
    
    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters);
    
    if (queryParams) {
        queryParams =  "?" + queryParams;
    } else {
        queryParams = '';
    }

    console.log("apiEndpoint", apiEndpoint);
    console.log("parameters", parameters);
    console.log("headers", headers);
    console.log("azureSubscriptionKey", azureSubscriptionKey);
    

    let result = axios.get(apiEndpoint + queryParams, {
        headers: headers
    });

    console.log("HttpActualGet result", result);
    
    return result
}

const HttpActualPost = (path, payload, azureSubscriptionKey, xProfileUid, accessToken) => {

    let headers = {}

    if (accessToken) {
        headers = {
            ...headers,
            Authorization: `Bearer ${accessToken}`
        };
    }
    
    if (azureSubscriptionKey) {
        headers = {
            ...headers,
            'Ocp-Apim-Subscription-Key': azureSubscriptionKey
        };
        
    }

    if (xProfileUid) {
        headers = {
            ...headers,
            "x-profile-uid": xProfileUid
        };
    }

    let apiEndpoint = path;
    
    console.log("apiEndpoint", apiEndpoint);
    console.log("payload", payload);
    console.log("headers", headers);
    console.log("azureSubscriptionKey", azureSubscriptionKey);
    

    let result = axios.post(apiEndpoint, payload, {
        headers: headers
    });

    console.log("HttpActualPost result", result);
    return result
}

const HttpActualPostParams = (path, parameters, azureSubscriptionKey, xProfileUid, accessToken) => {
    let headers = {}

    if (accessToken) {
        headers = {
            ...headers,
            Authorization: `Bearer ${accessToken}`
        };
    }
    
    if (azureSubscriptionKey) {
        headers = {
            ...headers,
            'Ocp-Apim-Subscription-Key': azureSubscriptionKey
        };
        
    }

    if (xProfileUid) {
        headers = {
            ...headers,
            "x-profile-uid": xProfileUid
        };
    }
    
    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters);
    
    if (queryParams) {
        queryParams =  "?" + queryParams;
    } else {
        queryParams = '';
    }

    console.log("apiEndpoint", apiEndpoint);
    console.log("parameters", parameters);
    console.log("headers", headers);
    console.log("azureSubscriptionKey", azureSubscriptionKey);
    

    let result = axios.post(apiEndpoint + queryParams, {}, { headers });

    console.log("HttpActualPostParams result", result);
    
    return result
}

const HttpActualPut = (path, payload, azureSubscriptionKey, xProfileUid, accessToken) => {
    
    let headers = {}

    if (accessToken) {
        headers = {
            ...headers,
            Authorization: `Bearer ${accessToken}`
        };
    }
    
    if (azureSubscriptionKey) {
        headers = {
            ...headers,
            'Ocp-Apim-Subscription-Key': azureSubscriptionKey
        };
        
    }

    if (xProfileUid) {
        headers = {
            ...headers,
            "x-profile-uid": xProfileUid
        };
    }



    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(payload);
    
    if (queryParams) {
        queryParams =  "?" + queryParams;
    } else {
        queryParams = '';
    }

    console.log("apiEndpoint", apiEndpoint);
    console.log("queryParams", queryParams);
    console.log("payload", payload);
    console.log("headers", headers);
    console.log("azureSubscriptionKey", azureSubscriptionKey);
    

    let result = axios.put(apiEndpoint + queryParams, payload,{
        headers: headers
    });

    console.log("HttpActualPut result", result);

    return result;
}


const HttpActualPutParamsPayload = (path, parameters, payload, azureSubscriptionKey, xProfileUid, accessToken) => {    
    let headers = {}

    if (accessToken) {
        headers = {
            ...headers,
            Authorization: `Bearer ${accessToken}`
        };
    }
    
    if (azureSubscriptionKey) {
        headers = {
            ...headers,
            'Ocp-Apim-Subscription-Key': azureSubscriptionKey
        };
        
    }

    if (xProfileUid) {
        headers = {
            ...headers,
            "x-profile-uid": xProfileUid
        };
    }



    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters);
    
    if (queryParams) {
        queryParams =  "?" + queryParams;
    } else {
        queryParams = '';
    }

    console.log("apiEndpoint", apiEndpoint);
    console.log("queryParams", queryParams);
    console.log("payload", payload);
    console.log("headers", headers);
    console.log("azureSubscriptionKey", azureSubscriptionKey);
    

    let result = axios.put(apiEndpoint + queryParams, payload,{
        headers: headers
    });

    console.log("HttpActualPutParamsPayload result", result);

    return result;
}

const HttpActualPutPayload = (path, payload, azureSubscriptionKey, xProfileUid, accessToken) => {

    let headers = {}

    if (accessToken) {
        headers = {
            ...headers,
            Authorization: `Bearer ${accessToken}`
        };
    }
    
    if (azureSubscriptionKey) {
        headers = {
            ...headers,
            'Ocp-Apim-Subscription-Key': azureSubscriptionKey
        };
        
    }

    if (xProfileUid) {
        headers = {
            ...headers,
            "x-profile-uid": xProfileUid
        };
    }


    let apiEndpoint = path;
    
    console.log("apiEndpoint", apiEndpoint);
    console.log("payload", payload);
    console.log("headers", headers);
    console.log("azureSubscriptionKey", azureSubscriptionKey);
    

    let result = axios.put(apiEndpoint, payload, {headers: headers})

    console.log("HttpActualPutPayload result", result);
    return result
}

const HttpActualPutParams = (path, parameters, azureSubscriptionKey, xProfileUid, accessToken) => {    
    let headers = {}

    if (accessToken) {
        headers = {
            ...headers,
            Authorization: `Bearer ${accessToken}`
        };
    }
    
    if (azureSubscriptionKey) {
        headers = {
            ...headers,
            'Ocp-Apim-Subscription-Key': azureSubscriptionKey
        };
        
    }

    if (xProfileUid) {
        headers = {
            ...headers,
            "x-profile-uid": xProfileUid
        };
    }

    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters);
    
    if (queryParams) {
        queryParams =  "?" + queryParams;
    } else {
        queryParams = '';
    }

    console.log("apiEndpoint", apiEndpoint);
    console.log("queryParams", queryParams);
    console.log("headers", headers);
    console.log("azureSubscriptionKey", azureSubscriptionKey);
    

    let result = axios.put(apiEndpoint + queryParams, {}, {
        headers: headers
    });

    console.log("HttpActualPutParams result", result);

    return result;
}


const HttpActualPut1 = (path, parameters, payload, azureSubscriptionKey, xProfileUid, accessToken) => {

    let headers = {}

    if (accessToken) {
        headers = {
            ...headers,
            Authorization: `Bearer ${accessToken}`
        };
    }
    
    if (azureSubscriptionKey) {
        headers = {
            ...headers,
            'Ocp-Apim-Subscription-Key': azureSubscriptionKey
        };
        
    }

    if (xProfileUid) {
        headers = {
            ...headers,
            "x-profile-uid": xProfileUid
        };
    }

    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters);
    
    if (queryParams) {
        queryParams =  "?" + queryParams;
    } else {
        queryParams = '';
    }
    
    console.log("apiEndpoint", apiEndpoint);
    console.log("payload", payload);
    console.log("headers", headers);
    console.log("azureSubscriptionKey", azureSubscriptionKey);
    

    let result = axios.put(apiEndpoint + queryParams, payload, { headers: headers })

    console.log("HttpActualPut1 result", result);
    return result
}


const HttpActualDelete = (path, parameters, azureSubscriptionKey, xProfileUid, accessToken) => {
    
    let headers = {}

    if (accessToken) {
        headers = {
            ...headers,
            Authorization: `Bearer ${accessToken}`
        };
    }
    
    if (azureSubscriptionKey) {
        headers = {
            ...headers,
            'Ocp-Apim-Subscription-Key': azureSubscriptionKey
        };
        
    }

    if (xProfileUid) {
        headers = {
            ...headers,
            "x-profile-uid": xProfileUid
        };
    }

    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters);
    
    if (queryParams) {
        queryParams =  "?" + queryParams;
    } else {
        queryParams = '';
    }

    console.log("apiEndpoint", apiEndpoint);
    console.log("queryParams", queryParams);
    console.log("headers", headers);
    console.log("azureSubscriptionKey", azureSubscriptionKey);
    

    let result = axios.delete(apiEndpoint + queryParams,{
        headers: headers
    });

    console.log("HttpActualDelete result", result);

    return result;
}


export {HttpActualGet, HttpActualPost, HttpActualPostParams, HttpActualPut, HttpActualDelete, HttpActualPut1, HttpActualPutParamsPayload, HttpActualPutPayload, HttpActualPutParams}
